import { render, staticRenderFns } from "./AssetGridItem.vue?vue&type=template&id=5fb8e172&scoped=true"
import script from "./AssetGridItem.vue?vue&type=script&lang=js"
export * from "./AssetGridItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb8e172",
  null
  
)

export default component.exports